import { Button } from "components/Button/Button";
import { TabBar } from "components/Tabbar/Tabbar";
import { useEffect, useRef, useState } from "react";

//import { getCustomerForm, sendCustomer } from "./api";

import { CheckableButton } from "components/CheckableButton/CheckableButton";
import { Textbox } from "components/Textbox/Textbox";
import { Toast } from "components/ToastShow/ToastAlert";
import { MessageType } from "types/enum";
import { trans } from "utils/helpers";
import { MeetingApprovalList } from "../MeetingApproval/MeetingApprovalList";
import { Invitaion } from "./components/Invitaion/Invitaion";
import { InvitedPeopleList } from "./components/InvitedPeopleList/InvitedPeopleList";
import { SendInvitationApi, SendIsPreparedMeetingConditions, sendmeeting } from "./components/MeetingForm/api";
import { MeetingForm } from "./components/MeetingForm/MeetingForm";
import { useLocation } from "react-router-dom";


interface MeetingTabFormPropsType {
  onHide: () => void;
  reload:(e:boolean)=>void;
  closeForm?:()=>void;
  showForm:any;
  mode: any;
  selectedObj: any;
  jobId?:any;
  sourceId?:any;
  processId?:any;
  referenceId?:any;
  step:any;
  callAttachmentMoveTemp?:any
  
}
export const MeetingTabForm = ({ onHide,reload,closeForm,step=1,callAttachmentMoveTemp,selectedObj,showForm, mode,processId,sourceId,jobId ,referenceId  }: MeetingTabFormPropsType) => {
  const [curentTab, setCurentTab] = useState<any>(step>4?"meetingApproval":"MeetingForm")
  const [curentTab1, setCurentTab1] = useState<any>("MeetingForm")
  const MeetingData = useRef<any>();
  const invitaionData = useRef<any>();
  const formRefs = [useRef() as any, useRef() as any];
  const [loading , setLoading] = useState(false)
  const [listPosition,setListPosition] = useState<any>({})
  const [invitaionObj, setInvitaionObj] = useState<any>(null); 
  const [confirm,setConfirm]=useState<any>(false)
  const [disApprovalDes,setDisApprovalDes]=useState<any>()
  const [acceptExpireTime, setAcceptExpireTime] = useState<any>(null); 
  const [visitedInvitionForm,setVisitedInvitionForm]=useState<any>(false)
  const [defaultPeopleList,setDefaultPeopleList]=useState<any>(null)
  const lang = localStorage.getItem("DefaultLanguage");
  const delay = (duration) =>
  new Promise(resolve => setTimeout(resolve, duration));
  const isCurrent=useLocation()?.pathname?.includes('current')

  
  



  let content = [

// ...(step>4? [ { title:"meetingApproval",body: (
//        <>
//        <MeetingApprovalList
//                              sourceId= {sourceId}
//     mode={step==4 || step==5 ?'edit':'view'}
//     step={step==4 || step==6?1:2}
//     referenceId={referenceId}
//    // handleCancelForm:()=>void;
//     onHide={onHide}
//     closeForm={closeForm}
//     processId={processId}
//     handleShowReferenceStepper={true}
//                         />
//        </>
// ), },]:[])

    ,{ title: "MeetingForm",body: (<MeetingForm
       jobId={jobId}
       setInvitaionObj={setInvitaionObj}
       processId={processId}
       referenceId={referenceId}
       setDefaultPeopleList={setDefaultPeopleList}
       setAcceptExpireTime={setAcceptExpireTime}
       setListPosition={setListPosition} listPosition={listPosition} formRef={formRefs[0]} handleData={(e)=>{
        MeetingData.current = e
        if(e && mode=='create'){
            if(e!=undefined && invitaionData.current!=undefined){
                if(!visitedInvitionForm){
         Toast(trans(" لطفاً قبل از ذخیره، اطلاعات تب «مدعوین» را بررسی کنید"),MessageType.info);
setVisitedInvitionForm(true)
    return null 
  }
               formSubmit()
   }else{
    document.body.classList.remove("loading-indicator-"+lang);
  } 
        }
      }} showForm={showForm} step={step} mode={mode} reload={reload} onHide={()=>onHide()}/>), },





  
  ...(  step!=6 && step!=3 ? [ { title:"invitedpeople",body: (
       <>{
       ( step>1 && (mode!="edit" || step!=2)) ?
            <InvitedPeopleList
            meetingId={sourceId}
            JobId={jobId}
            onHide={() => {}}
            step={step}
            mode={step > 1 && (mode!="edit" || step!=2) ? "view" : mode}
         />
        :
        <Invitaion 
        step={step}
        sourceId={sourceId}
        jobId={jobId}
          formRef={formRefs[1]}
          intab={curentTab}
          acceptExpireTime={acceptExpireTime}
          InvitaionData={invitaionObj?.Meeting}
          meetingTabPeople={
             {"Main" : [...(defaultPeopleList ?Object.values(defaultPeopleList)?.filter((item :any)=>item).map((item:any)=>({...item,InvitedPersonType:item?.InvitedPersonType?item?.InvitedPersonType:1})):[])]}
          }
          defaultPeopleList={
            
            {Guest:invitaionObj?.InvitedPeople?.Guest,Ordinary
: invitaionObj?.InvitedPeople?.Ordinary,"Main" : [...(invitaionObj?.InvitedPeople?.Main && defaultPeopleList?invitaionObj?.InvitedPeople?.Main.filter(item1 => 
     !Object.values(defaultPeopleList).some((item2:any) => item2?.PositionId === item1?.PositionId)
   ):[]),...(defaultPeopleList ?Object.values(defaultPeopleList)?.filter((item :any)=>item).map((item:any)=>({...item,InvitedPersonType:item?.InvitedPersonType?item?.InvitedPersonType:1})):[])]}}
        mode={mode}
        InvitaionFormSubmit={(e)=>{invitaionData.current =e} }/>       
       }
       
       
       
       </>
), }]:[]),
...(step>3? [ { title:"meetingApproval",body: (
       <>
       <MeetingApprovalList
                             sourceId= {sourceId}
    mode={step==4 || step==5 ?'edit':'view'}
    step={step==4 || step==6?1:2}
    referenceId={referenceId}
   // handleCancelForm:()=>void;
    onHide={onHide}
    closeForm={closeForm}
    processId={processId}
    handleShowReferenceStepper={true}
                        />
       </>
), },]:[]),


    ];


    
let content1 = [

    { title: "MeetingForm",body:   (<MeetingForm
      jobId={jobId}
      setAcceptExpireTime={setAcceptExpireTime}
      selectedObj={selectedObj}
      setInvitaionObj={setInvitaionObj}
      processId={processId}
      referenceId={referenceId}
      setDefaultPeopleList={setDefaultPeopleList}
      setListPosition={setListPosition} listPosition={listPosition} formRef={formRefs[0]} handleData={(e)=>{
      ;MeetingData.current = e}} showForm={showForm} step={step} mode={mode} reload={reload} onHide={()=>onHide()}/>)
        
      },




   { title:"invitedpeople" ,body: (
       <> <InvitedPeopleList
            meetingId={selectedObj?.Id}
            JobId={jobId}
            onHide={() => {}}
            mode={step > 1 && (mode!="edit" || step!=2) ? "view" : mode}
         />
       
       
       
       </>
), },




 



    ];
    async function sendDataAsync(data, method) {


      try {
   if(mode=='view' && step==1 && isCurrent){//در تسک صدور دعوات نامه مجری جلسخ امکان تغییر متن دعون نامه و زمان قبول دعوت نامه را دارو و نمیتواند فرم اصلی میتینگ را تغییر دهد
     const res = await SendInvitationApi(data ,referenceId);

   }
   else if(mode=='view' && step==2 && isCurrent){
     const res = await SendIsPreparedMeetingConditions(referenceId,MeetingData.current?.Id);
   }
   else {
     const res = await sendmeeting(data, method ,processId ,referenceId,mode=='edit' && step==1?true:mode=='edit' && step==2?false:'');
 if(res.Data && mode=='create'){

        callAttachmentMoveTemp &&   callAttachmentMoveTemp(res.Data)
        }
   }
         sessionStorage.setItem("changingforms" , "false");
         closeForm &&closeForm()
         onHide&&onHide()
        showForm && showForm()
      } catch (err: any) {
      }
  }

  const tabChangeHandle = (tab) => {
    setCurentTab(tab)
    if(tab=="invitedpeople"&&   mode=='create'){
      if(!visitedInvitionForm){
             setVisitedInvitionForm(true)
      }
    }
  } 
   const tabChangeHandle1 = (tab) => {
    setCurentTab1(tab)
  } 
  async function formSubmit() {
    const seen = new Set();
    await delay(20)
          try {
        if(mode=="create"){
          let obj = {
            Meeting: {
                ...MeetingData.current,
                AcceptExpireTime:invitaionData.current.AcceptExpireTime,
                InvitationText:invitaionData.current.InvitationText,
            } ,
            InvitedPeople: invitaionData.current.InvitedPeople.filter(item => {
  if (seen.has(item.PositionId)) return false;
  seen.add(item.PositionId);
  return true;
})
        }
             sendDataAsync(obj , "post")
        }else{
           if(mode=='edit' && step==2 && !confirm && !disApprovalDes){
     Toast(trans(" شرح عدم تایید اجباری است "),MessageType.error);
        return 
      }
          let obj
    if(mode=='view' && step==1){//تسک صدور دعوت نامه قابلیت تغییر در فرم دعوت نامه را دارد
                 obj = {
meetingId:MeetingData.current?.Id,
  AcceptExpireTime:invitaionData.current.AcceptExpireTime,
                InvitationText:invitaionData.current.InvitationText,
        }

    }
    else if(mode!='view'){
     
           obj = {
            Meeting: {
                ...MeetingData.current,
                ...(mode=='edit' && step==2 && !confirm ?{BossRejectionDescription:disApprovalDes}:{}),
                AcceptExpireTime:invitaionData.current.AcceptExpireTime,
                InvitationText:invitaionData.current.InvitationText,
            } ,
            InvitedPeople: invitaionData.current.InvitedPeople.filter(item => {
  if (seen.has(item.PositionId)) return false;
  seen.add(item.PositionId);
  return true;
})
        }
      }
       sendDataAsync(obj , "put")

        }
       
        } catch (error) {
    
        }
        document.body.classList.remove("loading-indicator-"+lang);
}


   const handleSubmitAllForms = async(e) => {
  let flag=true ; 
  await Promise.all(
    formRefs.map(async (formRef:any) => {
      if(formRef.current?.checkValidity()&&flag){
        formRef.current?.hidebutton?.click();
      }else if(flag){
        flag = false
        setCurentTab(formRef.current?.name)
        await delay(50)
        formRef.current?.reportValidity()
      }
    })
  );

// if(!visitedInvitionForm && ((mode=='edit' && step==2) || (mode=='view' && (step==2 || step==1))) ){
              
//          Toast(trans(" لطفاً قبل از ذخیره، اطلاعات تب «مدعوین» را بررسی کنید"),MessageType.info);
// setVisitedInvitionForm(true)
//     return null 
  
// }

  if(mode!='create'){
    await delay(50)
    if((MeetingData.current!=undefined && invitaionData.current!=undefined) || (mode=='view' && (step==1 || step==2)) ){//در فرم صدور دعوت نمه فقط فرم دعوت نامه قابل تغییر و ارسال هست پس فرم میتینگ و لازم ندارم ک اعتبار سنجی کنیم
        formSubmit()
     }else{
      document.body.classList.remove("loading-indicator-"+lang);
    }  
  }

    

  }

  

useEffect(() => {
      if (mode!="create"&& selectedObj?.Id) {

    }else{
      setLoading(true)
    }
}, []);

useEffect(() => {
    


}, [invitaionObj]);


  return (
    <div className="card-body">
    

      {(mode=="view"  && ( window.location.href?.includes('meetings')))?
<TabBar  tabChange={tabChangeHandle1} content={content1} curentTab={curentTab1} defaultTab={"MeetingForm"} />

    :
 false ?   <MeetingForm
      jobId={jobId}
      setAcceptExpireTime={setAcceptExpireTime}
      selectedObj={selectedObj}
      setInvitaionObj={setInvitaionObj}
      processId={processId}
      referenceId={referenceId}
      setDefaultPeopleList={setDefaultPeopleList}
      setListPosition={setListPosition} listPosition={listPosition} formRef={formRefs[0]} handleData={(e)=>{
      ;MeetingData.current = e}} showForm={showForm} step={step} mode={mode} reload={reload} onHide={()=>onHide()}/>:
    <TabBar  tabChange={tabChangeHandle} content={content} curentTab={curentTab} defaultTab={step>4?"meetingApproval":"MeetingForm"} />

    }


{(mode=='edit' && step==2) ?
<div className="card-body">




  <div className="row align-items-center mt-1">
                <div className="col-2 mt-1">
                    <CheckableButton
                      onchange={(e) =>
                        e && setConfirm(true)
                      }
                      defaultChecked={confirm == true?true:false}
                      labelText={"ok"}
                      inputName={"confirm"}
                      type="radio"
                    />
                  </div>  
                  <div className="col-2 mt-1 ">
                                      <CheckableButton
                                         onchange={(e) =>
                                          e && setConfirm(false)
                                        }
                                        defaultChecked={confirm == false?true:false}
                                        labelText={"decline"}
                                        inputName={"confirm"}
                                        type="radio"
                                      />
                                    </div>      
       {!confirm?
  <div className="col ">
                                <Textbox
                                 required
                                 textboxType="textarea"
                                 textboxName="BossRejectionDescription"
                                 labelText="شرح عدم تایید"
                                 maxLength={900}
                                 minHeight={2}
onChange={(e)=>setDisApprovalDes(e.target.value)}

                                />
                            </div>
:<></>}
                  </div>




</div>
:<></>}
      <div className="d-flex justify-content-end my-3 mx-1" >
        { 
        //.مد ایجاد دکمه ذخیره و ارجاع دارد.مد ادیت در تسک تایید دستور جلسه توسط رییس و نباید استپ 4 باشد چون استپ 4 مربوط به تسک برگزاری جلسه و تنظیم صوت جلسه و توی این تسک نباید دکمه ای دیده شود پس شرط نامساوی 4 باید در مد ادیت باشد. در مد ویو هم باید عدد استپ مشخص شود که میشود تسک صدور دعوت نامه و تسک های دیگه در مد ویو نباید این دکمه را داشته باشند
        (((mode=='create') || (mode=='edit' && (step==2 || step==1)) 
        ) || (mode=='view' && (step==1 || step==2) && isCurrent))?
          
          <Button onClick={handleSubmitAllForms} btnType="submit" value={mode=="create" || (mode=="edit" && step==1)? "saveandreference" :  (mode=='view' && step==2 && isCurrent)?'برگزاری جلسه':(mode=="view" && step==1)?"sendinvitationandrefer":confirm?'تایید رئیس جلسه و ارجاع':'عدم تایید جلسه'}  />
          :
          <></>
          
        }
      </div>

       </div>

    
  )
}